import { render, staticRenderFns } from "./vendorAssociatedClinicList.vue?vue&type=template&id=8d823694&"
import script from "./vendorAssociatedClinicList.vue?vue&type=script&lang=js&"
export * from "./vendorAssociatedClinicList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports